import { API } from "../backend";

export const updateProgress = (playlistId, videoId, token) => {
  return fetch(`${API}/progress/${playlistId}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ videoId }),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const getPlaylistProgress = (playlistId, token) => {
  return fetch(`${API}/progress/${playlistId}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const getAllUserProgress = (token) => {
  return fetch(`${API}/progress`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};
